module.exports = __webpack_public_path__ + "media/slots_arthurs_camelot_ambiance.eb42b359.mp3";